import { render, staticRenderFns } from "./CourseAdmins.vue?vue&type=template&id=010b64fa"
import script from "./CourseAdmins.vue?vue&type=script&lang=js"
export * from "./CourseAdmins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports